import { type ComponentProps } from 'react';
import { Slot } from '@radix-ui/react-slot';

import { cn } from '@/util/utils';

type TextLinkProps = ComponentProps<'a'> & {
    /** Render the child instead of an anchor, so a router `Link` can carry the style. */
    asChild?: boolean;
};

/**
 * A link inside running text or on a field's label row: the primary green, body size, an
 * underline that arrives on hover and sits clear of the descenders. Buttons are for actions
 * and carry the condensed uppercase label; this is for going somewhere, and reads like a
 * sentence. Not in the prototype, which has no text links; drawn from its tokens.
 */
function TextLink({ asChild, className, ...props }: TextLinkProps) {
    const Comp = asChild ? Slot : 'a';
    return (
        <Comp
            data-slot="text-link"
            className={cn(
                'text-primary focus-visible:outline-ring inline-flex items-center gap-1 rounded-xs text-sm leading-5 underline-offset-4 transition-colors duration-(--duration-fast) outline-none hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-solid [&_svg]:size-3.5 [&_svg]:shrink-0',
                className,
            )}
            {...props}
        />
    );
}

export { TextLink, type TextLinkProps };
